export const cashDiscountsSubMenu = [{
  path: '/cash-discounts/list',
  component: () => import('@/views/master/cash-discounts/list.vue'),
  name: 'cashDiscounts',
  meta: {
    title: 'master.cashDiscounts.title',
    noCache: true,
    icon: 'discount'
  }
}, {
  path: '/cash-discounts/add',
  component: () => import('@/views/master/cash-discounts/manage.vue'),
  name: 'Add Cash Discount',
  props: {
    isEdit: false
  },
  meta: {
    title: 'master.cashDiscounts.add',
    noCache: true,
    activeMenu: '/cash-discounts/list',
    hidden: true
  }
}, {
  path: '/cash-discounts/edit/:id(\\d+)',
  component: () => import('@/views/master/cash-discounts/manage.vue'),
  name: 'Edit Cash Discount',
  props: {
    isEdit: true
  },
  meta: {
    title: 'master.cashDiscounts.edit',
    noCache: true,
    activeMenu: '/cash-discounts/list',
    hidden: true
  }
}];